import type { Publication, TimelineRecord } from "../types";

const typeLabels = {
  international: "International",
  domestic: "Domestic",
  book: "Book · Report"
} as const;

export function PublicationRow({
  publication,
  showYear = true
}: {
  publication: Publication;
  showYear?: boolean;
}) {
  const content = (
    <>
      {showYear ? <span className="publication-year">{publication.year}</span> : null}
      <span className="publication-title" lang="en">
        {publication.title}
      </span>
      <span className="publication-venue">
        {publication.venue || typeLabels[publication.type]}
      </span>
      <span className="publication-arrow" aria-hidden="true">
        {publication.url ? "↗" : "—"}
      </span>
    </>
  );

  if (!publication.url) {
    return <div className="publication-row">{content}</div>;
  }

  return (
    <a
      className="publication-row"
      href={publication.url}
      target="_blank"
      rel="noreferrer"
      aria-label={`${publication.title}, 새 창에서 열기`}
    >
      {content}
    </a>
  );
}

export function TimelineList({
  records,
  headingLevel = 3
}: {
  records: TimelineRecord[];
  headingLevel?: 2 | 3;
}) {
  const Heading = headingLevel === 2 ? "h2" : "h3";
  return (
    <div className="timeline-list">
      {records.map((record, index) => (
        <article className="timeline-entry" key={`${record.year}-${record.title}-${index}`}>
          <time>{record.year}</time>
          <div>
            <Heading>{record.title}</Heading>
            {record.detail ? <p>{record.detail}</p> : null}
          </div>
        </article>
      ))}
    </div>
  );
}
